import BaseCarouselSlick from '../abstracts/BaseCarouselSlick';

export default class CarouselSliderNav extends BaseCarouselSlick {

  get SELECTORS() {
    return {
      wrapper: '#carousel-slider-wrap',
      navigationList: '.carousel-nav-list',
      navigationItem: '.carousel-nav-item'
    }
  }

  get CLASSES() {
    return {
      active: 'active',
    }
  }

  constructor(element) {
    super(element);
    this.mount(this.$el, this.$options);
    this.setNavHeight();
    this.onResizeWindow();
  }

  mount(element, options) {
    this.setNavHeight();
    this.wrapperPaddingCollapse();

    $(element).slick({
      ...this.BASE_CONF,
      ...options
    })

    $(element).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      const item = document.querySelector(`[data-slide='${nextSlide}']`);
      $(this.SELECTORS.navigationItem).removeClass(this.CLASSES.active);
      $(item).addClass(this.CLASSES.active);
      this.scrollToElement(item);
    });

    $(document).on('click', this.SELECTORS.navigationItem, function(e) {
      const slideNumber = parseInt($(this).attr('data-slide'));
      $(element).slick("slickGoTo", slideNumber);
    });

  }

  setNavHeight() {
    const large = window.matchMedia("(min-width: 1024px)");
    if (!large.matches) return;

    setTimeout(()=> {
      const imgHeight = $(this.$el).find('img').height();
      $(this.SELECTORS.navigationList).height(imgHeight > 0 ? imgHeight : 600);
    }, 250);
  };

  wrapperPaddingCollapse() {
    const large = window.matchMedia("(min-width: 1024px)");
    const currentBreakpoint = large.matches ? 'large' : 'small';
    const wrapper = $(this.SELECTORS.wrapper);
    currentBreakpoint === 'small' ? wrapper.addClass('small-padding-collapse') : wrapper.removeClass('small-padding-collapse');
  };

  onResizeWindow() {
    window.addEventListener('resize', (e) => {
      this.wrapperPaddingCollapse();
      this.setNavHeight();
    });
  }

  scrollToElement = (element) => {
    let $innerListItem = $(element),
        $parentDiv = $(element).parent().parent();
    $parentDiv.scrollTop($parentDiv.scrollTop() + $innerListItem.position().top );
  };
}